import { gql } from '@apollo/client';
import { LOCK_FRAGMENTS } from './fragments';

export const PARTY_UNLOCK = gql`
  ${LOCK_FRAGMENTS}
  mutation PartyUnlock($data: PartyLockInput!) {
    partyUnlock(data: $data) {
      lock {
        ...PartyLockFields
      }
    }
}`;
